import React from 'react';
import FAQ from '@/src/components/faq/FAQ';

export const FaqPage: React.FC = () => {
  return <FAQ />;
};
